import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class StackedBarChart extends Vue {
  @Prop() propertiesToChart!: {
    indexSectionOfDashboard: number;
    indexCollectionFilter: number;
    groupBy: DynamicSelectData[];
    chartType: string;
    isHorizontal: boolean;
    chartColor: { hex: string };
  };

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  chartOptions = {};
  mounted() {
    console.log("mounted stackedbar", this.propertiesToChart);
    this.chart();
  }

  @Watch("propertiesToChart", { deep: true })
  onChangeData() {
    this.chart();
  }

  chart() {
    const dataToGraph = this.sectionsOfDashboardStore[
      this.propertiesToChart.indexSectionOfDashboard
    ].collections[0];
    console.log("dataToGraph", dataToGraph);

    const series = dataToGraph.chartData.data.map((item: any) => ({
      name: item.name,
      type: "bar",
      stack: item.stack,
      barWidth: "10%",
      label: {
        show: item.labelBar ? true : false,
        formatter: item.labelBar,
        position: "top",
        color: "black"
      },
      data: item.data
    }));
    const groups = Object.values(dataToGraph.chartData.groups);

    let yAxis: any = { type: "value" };
    let xAxis: any = { type: "category", data: dataToGraph.chartData.xAxis };
    if (this.propertiesToChart.chartType.includes("horizontal")) {
      yAxis = { type: "category", data: dataToGraph.chartData.xAxis };
      xAxis = { type: "value" };
    }
    console.log(
      "this.propertiesToChart.chartColor",
      this.propertiesToChart.chartColor
    );

    this.chartOptions = {
      color: Utils.generateColorsTones(
        this.propertiesToChart.chartColor.hex,
        3
      ) as never[],
      tooltip: { trigger: "item" },
      legend: { data: groups[groups.length - 1] },
      grid: { left: 0, right: 0, top: 50, bottom: 50, containLabel: true },
      xAxis,
      yAxis,
      series
    };
  }
}
